export const HomePath = "/";
export const EducationPath = "/education";
export const NewsPath = "/news";
export const AboutPath = "/about";
export const CampPath = "/camp";
export const ShopPath = "/shop";
